// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disclaimer[data-v-40a87730]{color:#545766;font-size:.6rem;margin:24px auto 0;max-width:1225px;padding:15px}.disclaimer a[data-v-40a87730]{--tw-text-opacity:1;color:rgb(38 94 245 / var(--tw-text-opacity))}.disclaimer a[data-v-40a87730]:hover{color:#0d47a1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
